export default {
  namespaced: true,
  state: {
    news: [],
    unreadNewsCount: 0,
    publication: null,
    instructions: [],
    instruction: null,
    docs: [],
    categories: [],
    doc: null,
  },
  actions: {
    GetNews({ commit, rootGetters, dispatch }, id) {
      commit('setField', { name: 'news', value: [] });
      return new Promise((resolve, reject) => {
        rootGetters.axl.post('news/api/news', { profile_id: id })
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'news', value: response.data.news });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    GetUnreadNewsCount({ commit, rootGetters, dispatch }, id) {
      commit('setField', { name: 'news', value: [] });
      return new Promise((resolve, reject) => {
        rootGetters.ax.post('news/api/news', { profile_id: id })
          .then((response) => {
            if (response && response.data) {
              const unreadNew = response.data.news.filter(n => !n.readed);
              console.log(response.data);
              commit('setField', { name: 'unreadNewsCount', value: unreadNew.length });
              resolve(unreadNew.length);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    SetPublication({ state, commit }, id) {
      return new Promise((resolve) => {
        commit('setField', { name: 'publication', value: null });
        const tmpArray = state.news.filter(item => item.id === id);
        tmpArray.length && commit('setField', { name: 'publication', value: tmpArray[0] });
        resolve(tmpArray[0]);
      });
    },
    SetPublicationReaded({ rootGetters, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        rootGetters.ax.post('news/api/news/readed', {
          profile_id: payload.profile_id,
          news_id: payload.news_id,
        })
          .then((response) => {
            dispatch('GetUnreadNewsCount', payload.profile_id);
            resolve(response);
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    GetInstructions({ commit, rootGetters, dispatch }, id) {
      commit('setField', { name: 'instructions', value: [] });
      return new Promise((resolve, reject) => {
        rootGetters.ax.post('news/api/instructions', { profile_id: id })
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'instructions', value: response.data.instructions });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    GetCategoryDocs({ commit, rootGetters, dispatch }, id) {
      commit('setField', { name: 'categories', value: [] });
      return new Promise((resolve, reject) => {
        rootGetters.ax.post('docs/api/doc/list-categories', { profile_id: id })
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'categories', value: response.data.categories });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    GetDocs({ commit, rootGetters, dispatch }, data) {
      commit('setField', { name: 'docs', value: [] });
      return new Promise((resolve, reject) => {
        rootGetters.ax.post('docs/api/doc/list-by-group-and-category', data)
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'docs', value: response.data.products });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    GetDoc({ commit, rootGetters, dispatch }, id) {
      commit('setField', { name: 'doc', value: null });
      return new Promise((resolve, reject) => {
        rootGetters.ax.post('docs/api/doc/view', { product_id: id })
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'doc', value: response.data.product });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    SetInstruction({ state, commit }, id) {
      return new Promise((resolve) => {
        commit('setField', { name: 'instruction', value: null });
        const tmpArray = state.instructions.filter(item => item.id === id);
        tmpArray.length && commit('setField', { name: 'instruction', value: tmpArray[0] });
        resolve(tmpArray[0]);
      });
    },
    SetInstructionReaded({ rootGetters, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        rootGetters.ax.post('news/api/instructions/readed', {
          profile_id: payload.profile_id,
          instruction_id: payload.instruction_id,
        })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    InitialStoreNews({ commit }) {
      commit('setField', { name: 'news', value: [] });
      commit('setField', { name: 'unreadNewsCount', value: 0 });
      commit('setField', { name: 'publication', value: null });
      commit('setField', { name: 'instructions', value: [] });
      commit('setField', { name: 'instruction', value: null });
    },
  },
  mutations: {
    setField(state, payload) {
      state[payload.name] = payload.value;
    },
  },
};
